
import React from 'react';
import Button from './Button';

const QuotaHelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex justify-center items-center p-4" 
      aria-modal="true" 
      role="alertdialog"
    >
      <div className="bg-white rounded-lg shadow-2xl p-6 md:p-8 w-full max-w-2xl mx-auto space-y-6">
        <div className="text-center">
            <svg className="w-16 h-16 mx-auto text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="mt-4 text-2xl font-extrabold text-secondary-800">API Usage Limit Reached</h2>
        </div>

        <p className="text-base text-secondary-600 text-center">
          The application could not complete the request because the Gemini API's usage quota has been exceeded. This is a temporary issue related to your API key's usage limits.
        </p>

        <div className="space-y-4 text-left">
          <h3 className="text-lg font-semibold text-secondary-700">What you can do:</h3>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">1</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Wait and Retry</h4>
              <p className="text-sm text-secondary-600">
                Usage quotas often reset after a short period (e.g., per minute). The simplest solution is to wait a minute and try the operation again.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">2</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Check Your Usage</h4>
              <p className="text-sm text-secondary-600">
                Review your current API key usage in the Google AI Studio dashboard to see if you have reached a limit.
              </p>
              <a href="https://aistudio.google.com/app/apikey" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-primary-600 hover:underline">
                View API Keys in Google AI Studio &rarr;
              </a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold text-lg">3</div>
            <div>
              <h4 className="font-semibold text-secondary-800">Review Your Billing Plan</h4>
              <p className="text-sm text-secondary-600">
                If you are on a free tier, you may need to enable billing on your Google Cloud project to increase your quota. If billing is enabled, check if you have set a budget or spending limit that has been reached.
              </p>
               <a href="https://console.cloud.google.com/billing" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-primary-600 hover:underline">
                Go to Google Cloud Billing &rarr;
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 flex justify-center">
          <Button variant="primary" size="lg" onClick={onClose}>
            Got it, I'll check my settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuotaHelpModal;
